import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/render/project/src/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { HeroLayout } from '@primer/gatsby-theme-doctocat';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = HeroLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`Page 1`}</p>
    <h1>{`this is a first article`}</h1>
    <p>{`let us develop our topic for a moment`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      